import { UserCheck } from "react-feather"

export default [
    {
        id: "home1",
        title: "Ирц",
        // icon: <i className="fal fa-"></i>,//
        icon: <UserCheck size={20} />,
        navLink: "/irts"
    },
]
